import { AppSelector } from 'app/store'
import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'

export const kaapiEventsSelector: AppSelector<any[]> = createSharedSelector(
  getDataSelector<DataKeys.KaapiEvents>(DataKeys.KaapiEvents),
  (kaapiEvents): any[] => kaapiEvents,
)
